import React, { useState, useEffect } from "react";
import _ from "lodash";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { reorderArray, showAlert } from "../../../../config/utils";
import viewIcon from "../../../../assets/img/Group 138.svg";
import OuterDraggable from "react-draggable";
import reportAction from "../../../reportProperties/actions";
import { useDispatch, useSelector } from "react-redux";
import TileCustomHeading from "../TileCustomHeading";
import actions from "../../actions";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";
import Portal from "../../../common/components/Portal";
import { BbiTableConfig } from "./BbiTableConfig";
import ExecutiveSummaryTable from "./ExecutiveSummaryTable";
import "../../smartCharts.css";
import ReactTooltip from "react-tooltip";

const ConfigModal = ({
    getListParams = {},
    configData = {},
    onCancel,
    viewOnly = false,
    isExcelExport = false,
    isSkeletonView,
    modalheading = "",
    selectedTileData = {},
    isBbi = false,
    isBuildingBbi = false,
    trade_ids,
    dynamicBands,
    simpleNarrativeTextValue,
    onSave,
    btnName = "save",
    isLoading = false,
    property_id = null,
    isView = false,
    isBsi = false,
    isSiteBsi = false,
    isBai = false
}) => {
    const dispatch = useDispatch();
    const [chartConfigData, setChartConfigData] = useState(["table_view", "executive_summary_data", "stop_light"]);
    const [defChartView, setChartView] = useState([
        { title: `${modalheading} Table`, key: `table_view` },
        { title: `Stoplight`, key: `stop_light` },
        { title: `${modalheading} Executive Summary Bands`, key: `executive_summary_data` }
    ]);

    const [selectedTile, setSelectedTile] = useState(`table_view`);
    const [transform, setTransform] = useState({ left: 0, top: 0 });
    const [showTableConfig, setTableConfig] = useState(false);
    const [bbiTableFields, setBbiFields] = useState(selectedTileData?.export_property?.building_fields || []);
    const [heading, setHeading] = useState({
        table_view: true,
        executive_summary_data: true,
        stop_light: true,
        table_main: true
    });
    const [isCustomTypeHeading, setIsCustomTypeHeading] = useState({
        table_view: false,
        executive_summary_data: false,
        stop_light: false,
        table_main: false
    });
    const [headingStyleData, setHeadingStyleData] = useState({
        table_view: {
            name: "",
            bold: false,
            color: "ffffff",
            font_size: 10,
            font_id: "",
            bg_color: "003f2d",
            alignment: "left",
            cell_margin: { top: 0.04, left: 0.04, right: 0.04, bottom: 0.04 },
            heading_style: "Heading 3"
        },
        table_main: {
            name: "",
            bold: false,
            color: "ffffff",
            font_size: 10,
            font_id: "",
            bg_color: "003f2d",
            alignment: "left",
            cell_margin: { top: 0.04, left: 0.04, right: 0.04, bottom: 0.04 },
            heading_style: "Heading 3"
        },
        executive_summary_data: {
            name: "",
            bold: false,
            color: "ffffff",
            font_size: 10,
            font_id: "",
            bg_color: "003f2d",
            alignment: "left",
            cell_margin: { top: 0.04, left: 0.04, right: 0.04, bottom: 0.04 },
            heading_style: "Heading 3"
        },

        stop_light: {
            name: "",
            bold: false,
            color: "ffffff",
            font_size: 10,
            font_id: "",
            bg_color: "003f2d",
            alignment: "left",
            cell_margin: { top: 0.04, left: 0.04, right: 0.04, bottom: 0.04 },
            heading_style: "Heading 3"
        }
    });

    const [error, setError] = useState({ table_view: false, summary_view: false, detailed_view: false });
    const [selectedData, setSelectedData] = useState({
        trades: [],
        dynamicFields: {},
        displayType: selectedTileData?.export_property?.extra_config?.fci?.displayType || "percentage",
        simpleText: true,
        additions: [],
        showAdditions: selectedTileData?.export_property?.show_additions ?? true,
        bbi_table_memo_simple_text: selectedTileData?.export_property?.extra_config?.bbi_table_memo_simple_text ?? true,
        bbi_table_date_format: selectedTileData?.export_property?.extra_config?.bbi_table_date_format ?? "standard-us-numeric"
    });
    const { getBuildingTradeData, getDefaultBbiProperty, getDefaultBsiProperty } = useSelector(state => state?.smartChartReducer);
    const [tradeAdditionValues, setTradeAdditionValues] = useState({
        trades: [],
        additions: []
    });
    const [pageBreak, setPageBreak] = useState({ table_view: false, executive_summary_data: false, stop_light: false });
    const [showBbiXsum, setBbiXsum] = useState(true);
    const [exportTradeRows, setExportTradeRows] = useState([]);
    const [showExecutiveExportTable, setShowExecutiveExportTable] = useState(false);

    useEffect(() => {
        return () => {
            dispatch(actions?.resetBuildingTradeData());
        };
    }, []);

    useEffect(() => {
        dispatch(reportAction?.getDropdownList("fonts"));
        if (isBsi || isBai)
            dispatch(
                actions?.getDefaultProperties(
                    {
                        client_id: getListParams?.client_ids?.[0] || getListParams?.client_id,
                        export_property_id: property_id
                    },
                    isBai ? "bai" : "bsi"
                )
            );
        else
            dispatch(
                actions?.getDefaultBBIProperties({
                    client_id: getListParams?.client_ids?.[0] || getListParams?.client_id,
                    export_property_id: property_id
                })
            );
        const params = {
            project_id: getListParams?.project_ids?.[0] || getListParams?.project_id,
            ...((isBbi || isBuildingBbi) && {
                building_id: getListParams?.building_ids?.[0] || getListParams?.building_id
            }),
            ...((isBsi || isSiteBsi) && { site_id: getListParams?.site_ids?.[0] || getListParams?.site_id }),
            ...(isBai && { addition_id: getListParams?.addition_ids?.[0] || getListParams?.addition_id })
        };
        dispatch(actions?.getBuildingTrades(params));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!getDefaultBbiProperty?.success && !getDefaultBsiProperty?.success) return;
        let bbi_heading, bbi_heading_executive_summary, stop_light, table_heading;
        if (isBsi || isBai) {
            ({
                bbi_heading,
                bbi_heading_executive_summary,
                stop_light,
                bbi_table: { table_heading } = {}
            } = getDefaultBsiProperty?.data?.default_property || {});
        } else {
            ({
                bbi_heading,
                bbi_heading_executive_summary,
                stop_light,
                bbi_table: { table_heading } = {}
            } = getDefaultBbiProperty?.data?.default_property || {});
        }

        const userTableViewConfig = selectedTileData?.export_property?.export_order?.bbi_table?.heading || null;
        const finalTableView = {
            ...headingStyleData.table_view,
            ...(bbi_heading?.custom_heading_props || {}),
            ...(userTableViewConfig?.custom_heading_props || {}),

            name: userTableViewConfig?.name ?? bbi_heading?.name,
            heading_style: userTableViewConfig?.structured_heading?.heading_style ?? bbi_heading?.structured_heading?.heading_style ?? "Heading 3"
        };

        const userTableMainConfig = selectedTileData?.export_property?.export_order?.bbi_table?.table_heading || null;
        const finalTableMain = {
            ...headingStyleData.table_main,
            ...(table_heading?.custom_heading_props || {}),
            ...(userTableMainConfig?.custom_heading_props || {}),

            name: userTableMainConfig?.name ?? table_heading?.name,
            heading_style: userTableMainConfig?.structured_heading?.heading_style ?? table_heading?.structured_heading?.heading_style ?? "Heading 3"
        };

        const userExecutiveSummaryConfig = selectedTileData?.export_property?.export_order?.executive_summary_data?.heading || null;
        const finalExecutiveSummary = {
            ...headingStyleData.executive_summary_data,
            ...(bbi_heading_executive_summary?.custom_heading_props || {}),
            ...(userExecutiveSummaryConfig?.custom_heading_props || {}),
            name: userExecutiveSummaryConfig?.name ?? bbi_heading_executive_summary?.name,
            heading_style:
                userExecutiveSummaryConfig?.structured_heading?.heading_style ??
                bbi_heading_executive_summary?.structured_heading?.heading_style ??
                "Heading 3"
        };

        const userStopLightConfig = selectedTileData?.export_property?.export_order?.stop_light?.main_heading || null;
        const finalStopLight = {
            ...headingStyleData.stop_light,
            ...(stop_light?.main_heading?.custom_heading_props || {}),
            ...(userStopLightConfig?.custom_heading_props || {}),
            name: userStopLightConfig?.name ?? stop_light?.main_heading?.name,
            heading_style:
                userStopLightConfig?.structured_heading?.heading_style ?? stop_light?.main_heading?.structured_heading?.heading_style ?? "Heading 3"
        };

        setHeadingStyleData(prev => ({
            ...prev,
            table_view: finalTableView,
            table_main: finalTableMain,
            executive_summary_data: finalExecutiveSummary,
            stop_light: finalStopLight
        }));
        setIsCustomTypeHeading({
            table_view: checkObjectKeyPresent(
                selectedTileData?.export_property ? userTableViewConfig?.custom_heading_props : bbi_heading?.custom_heading_props
            ),
            table_main: checkObjectKeyPresent(
                selectedTileData?.export_property ? userTableMainConfig?.custom_heading_props : table_heading?.custom_heading_props
            ),
            executive_summary_data: checkObjectKeyPresent(
                selectedTileData?.export_property
                    ? userExecutiveSummaryConfig?.custom_heading_props
                    : bbi_heading_executive_summary?.custom_heading_props
            ),
            stop_light: checkObjectKeyPresent(
                selectedTileData?.export_property ? userStopLightConfig?.custom_heading_props : stop_light?.main_heading?.custom_heading_props
            )
        });

        setPageBreak(prev => ({
            ...prev,
            table_view: selectedTileData?.export_property?.export_order?.bbi_table?.page_break || false,
            executive_summary_data: selectedTileData?.export_property?.export_order?.executive_summary_data?.page_break || false,
            stop_light: selectedTileData?.export_property?.export_order?.stop_light?.page_break || false
        }));

        if (selectedTileData?.export_property) {
            setHeading({
                table_view: !!userTableViewConfig,
                table_main: !!userTableMainConfig,
                executive_summary_data: !!userExecutiveSummaryConfig,
                stop_light: !!userStopLightConfig
            });
            setSelectedData({
                ...selectedData,
                trades: _.uniq([...selectedData?.trades, ...(trade_ids || [])]),
                dynamicFields: selectedTileData?.export_property?.dynamic_field,
                displayType: selectedTileData?.export_property?.extra_config?.fci?.display_type,
                simpleText: simpleNarrativeTextValue,
                bbi_table_memo_simple_text: selectedTileData?.export_property?.extra_config?.bbi_table_memo_simple_text,
                bbi_table_date_format: selectedTileData?.export_property?.extra_config?.bbi_table_date_format,
                additions: _.uniq(selectedTileData?.export_property?.executive_summary_additional_ids || [])
            });
            setBbiXsum(selectedTileData.export_property?.bbi_xsum);
            if (selectedTileData?.export_property?.export_order) {
                const updatedChartConfigData = Object.keys(selectedTileData.export_property.export_order).map(key =>
                    key === "bbi_table" ? "table_view" : key
                );
                setChartConfigData(updatedChartConfigData);
                const newChartView = reorderDefChartView(defChartView, updatedChartConfigData);
                setChartView(newChartView);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDefaultBbiProperty?.success, getDefaultBsiProperty?.success, selectedTileData?.export_property, simpleNarrativeTextValue, trade_ids]);

    const reorderDefChartView = (defaultViews, userKeys) => {
        const userSet = new Set(userKeys);
        const userOrderedViews = userKeys.map(k => defaultViews.find(view => view.key === k)).filter(Boolean);
        const leftoverViews = defaultViews.filter(view => !userSet.has(view.key));

        return [...userOrderedViews, ...leftoverViews];
    };
    useEffect(() => {
        if (!getBuildingTradeData?.success && !getBuildingTradeData?.loading && getBuildingTradeData?.error) {
            showAlert(getBuildingTradeData?.error);
        }
    }, [getBuildingTradeData]);

    useEffect(() => {
        if (getBuildingTradeData?.list) {
            setTradeAdditionValues({
                ...tradeAdditionValues,
                trades: [
                    ...(getBuildingTradeData?.list?.data?.building_trades || [])
                        .map(trade => ({
                            ...trade,
                            isProjectTrade: false
                        }))
                        ?.sort((a, b) => a?.name?.localeCompare(b?.name)),
                    ...(getBuildingTradeData?.list?.data?.project_trades || [])
                        .filter(
                            projectTrade =>
                                !(getBuildingTradeData?.list?.data?.building_trades || []).some(buildingTrade => buildingTrade.id === projectTrade.id)
                        )
                        .map(trade => ({
                            ...trade,
                            isProjectTrade: true
                        }))
                        ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                ],
                additions: getBuildingTradeData?.list?.data?.executive_summary_additional_ids || []?.sort((a, b) => a?.name?.localeCompare(b?.name))
            });
            const listExport = getBuildingTradeData?.list?.data?.executive_summary_ids ?? [];
            const savedExport = selectedTileData?.export_property?.executive_summary_ids ?? [];

            let newExportRows;
            if (
                savedExport?.length && isBbi
                    ? selectedTileData?.mfilter?.building_ids?.[0] === getListParams?.building_ids?.[0]
                    : isBsi
                      ? selectedTileData?.mfilter?.site_ids?.[0] === getListParams?.site_ids?.[0]
                      : selectedTileData?.mfilter?.addition_ids?.[0] === getListParams?.addition_ids?.[0]
            ) {
                newExportRows = _.uniqBy([...savedExport, ...listExport], "key");
            } else if (listExport?.length) {
                newExportRows = listExport;
            }
            setExportTradeRows(newExportRows ?? []);
            if (!trade_ids) {
                setSelectedData({
                    ...selectedData,
                    trades: _.uniq([...selectedData?.trades, ...(getBuildingTradeData?.list?.data?.building_trades || [])?.map(e => e.id)]),
                    additions: _.uniq([
                        ...selectedData?.additions,
                        ...(getBuildingTradeData?.list?.data?.executive_summary_additional_ids || [])?.map(e => e.id)
                    ])
                });
            }
        }
    }, [getBuildingTradeData?.list]);

    const handleChartConfigData = (action, chartView, params) => {
        const { is_remove = false } = params;
        switch (action) {
            case "view":
                if (is_remove) {
                    setChartConfigData(prevConfig => prevConfig.filter(item => item !== chartView));
                } else {
                    setChartConfigData(prevConfig => {
                        if (!prevConfig.includes(chartView) && chartView) {
                            return [...prevConfig, chartView];
                        }
                        return prevConfig;
                    });
                }
                break;

            case "allSelect":
                if (is_remove) {
                    setChartConfigData([]);
                } else {
                    setChartConfigData(["table_view", "executive_summary_data", "stop_light"]);
                }
                break;

            default:
                break;
        }
    };
    const handleClickCancel = () => {
        setChartConfigData([]);
        onCancel();
    };

    const handleClickSave = () => {
        let headingStyleValidation = {
            table_view: false,
            executive_summary_data: false,
            stop_light: false
        };
        let savedConfigData = {};
        chartConfigData
            .slice()
            .sort((a, b) => defChartView.findIndex(item => item.key === a) - defChartView.findIndex(item => item.key === b))
            .forEach(view => {
                const tileKey = view === "table_view" ? "bbi_table" : view;
                if (heading[view]) {
                    const headingData = {
                        name: headingStyleData?.[view]?.name,
                        ...(isCustomTypeHeading?.[view]
                            ? {
                                  custom_heading_props: Object.fromEntries(
                                      Object.entries(headingStyleData?.[view] || {}).filter(([key]) => key !== "name" && key !== "heading_style")
                                  )
                              }
                            : {
                                  structured_heading: {
                                      heading_style: headingStyleData?.[view]?.heading_style
                                  }
                              })
                    };
                    if (!headingStyleData?.[view]?.name?.trim()) {
                        headingStyleValidation = { ...headingStyleValidation, [view]: true };
                    } else {
                        headingStyleValidation = { ...headingStyleValidation, [view]: false };
                    }

                    savedConfigData[tileKey] = {
                        heading: headingData
                    };
                } else {
                    if (savedConfigData[tileKey]?.heading) {
                        delete savedConfigData[tileKey]?.heading;
                    }
                }

                if (view === "table_view") {
                    const view = "table_main";
                    if (heading[view]) {
                        const headingData = {
                            name: headingStyleData?.[view]?.name,
                            ...(isCustomTypeHeading?.[view]
                                ? {
                                      custom_heading_props: Object.fromEntries(
                                          Object.entries(headingStyleData?.[view] || {}).filter(([key]) => key !== "name" && key !== "heading_style")
                                      )
                                  }
                                : {
                                      structured_heading: {
                                          heading_style: headingStyleData?.[view]?.heading_style
                                      }
                                  })
                        };
                        if (!headingStyleData?.[view]?.name?.trim()) {
                            headingStyleValidation = { ...headingStyleValidation, [view]: true };
                        } else {
                            headingStyleValidation = { ...headingStyleValidation, [view]: false };
                        }

                        savedConfigData[tileKey] = {
                            ...savedConfigData[tileKey],
                            table_heading: headingData
                        };
                    } else {
                        if (savedConfigData[tileKey]?.table_heading) {
                            delete savedConfigData[tileKey]?.table_heading;
                        }
                    }
                }
                if (!savedConfigData[tileKey]) {
                    savedConfigData[tileKey] = {};
                }
                savedConfigData[tileKey].page_break = pageBreak[view] || false;
                savedConfigData[tileKey].page_break = pageBreak[view] || false;
                setError({ ...headingStyleValidation });
            });

        if (savedConfigData.stop_light?.heading) {
            savedConfigData.stop_light.main_heading = savedConfigData.stop_light?.heading;
            delete savedConfigData.stop_light?.heading;
        }
        const data = {
            dynamic_field: selectedData?.dynamicFields ?? {},
            extra_config: {
                fci: {
                    display_type: selectedData?.displayType ?? ""
                },
                ...(!isBsi && !isBai
                    ? {
                          bbi_table_memo_simple_text: selectedData?.bbi_table_memo_simple_text,
                          bbi_table_date_format: selectedData?.bbi_table_date_format
                      }
                    : {})
            },
            bbi_xsum: showBbiXsum,
            export_order: {
                ...savedConfigData
            },
            // executive_summary_trade_ids: selectedData?.trades ?? [],
            executive_summary_ids: exportTradeRows,
            // executive_summary_additional_ids: selectedData?.additions ?? [],
            simple_text: selectedData?.simpleText,
            building_fields: bbiTableFields,
            ...(isBai ? {} : { show_additions: selectedData?.showAdditions })
        };

        if (!Object.values(headingStyleValidation)?.some(value => value === true)) {
            onSave(data, chartConfigData);
        }
    };

    const getIconsForView = view => {
        switch (view) {
            case "stop_light":
                return "smart-chart-chart-icon-item.svg";
            case `table_view`:
            case `executive_summary_data`:
                return "sm-charts-table-blue-icon.svg";
            default:
                break;
        }
    };

    const handleDrag = (e, ui) => {
        const { x, y } = ui;
        setTransform({ left: x, top: y });
    };
    const projectTradeData = tradeAdditionValues?.trades?.filter(data => data?.isProjectTrade);
    const handleExportTradeSummaryCheckboxClick = e => {
        const isChecked = e.target.checked;
        const projectTradeIds = projectTradeData?.map(t => t?.id);
        setExportTradeRows(prev =>
            prev.map(row => {
                if (projectTradeIds?.includes(row?.id)) {
                    return {
                        ...row,
                        export: isChecked ? "yes" : "no"
                    };
                }
                return row;
            })
        );
    };
    const handleCheckboxClick = (type, id) => {
        setSelectedData(prevSelectedData => {
            return {
                ...prevSelectedData,
                [type]: prevSelectedData?.[type]?.includes(id)
                    ? prevSelectedData[type].filter(tradeId => tradeId !== id)
                    : [...prevSelectedData?.[type], id]
            };
        });
    };
    const handleCheckboxChange = (group, fieldKey) => {
        setSelectedData(prevState => {
            const updatedFields = { ...prevState.dynamicFields };

            if (!updatedFields[group]) {
                updatedFields[group] = [];
            }

            if (updatedFields[group].includes(fieldKey)) {
                updatedFields[group] = updatedFields[group].filter(f => f !== fieldKey);
            } else {
                updatedFields[group] = [...updatedFields[group], fieldKey];
            }

            if (updatedFields[group].length === 0) {
                delete updatedFields[group];
            }

            return { ...selectedData, dynamicFields: updatedFields };
        });
    };

    const handleGroupCheckboxChange = (group, fields) => {
        setSelectedData(prevState => {
            const updatedFields = { ...prevState.dynamicFields };
            const groupFields = fields.map(field => field.field_name);

            if ((updatedFields[group] || []).length === groupFields.length) {
                delete updatedFields[group];
            } else {
                updatedFields[group] = groupFields;
            }

            return {
                ...prevState,
                dynamicFields: updatedFields
            };
        });
    };

    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const keyList = reorderArray(defChartView, result.source.index, result.destination.index);
        setChartView(keyList);
    };

    const handleExecutiveExportTableSave = rows => {
        setExportTradeRows(rows);
        setShowExecutiveExportTable(false);
    };

    const checkObjectKeyPresent = obj => {
        return obj && Object.keys(obj)?.length > 0 ? true : false;
    };

    const toggleTableConfig = () => setTableConfig(!showTableConfig);

    const renderTableConfig = () => {
        if (!showTableConfig) return null;
        const { name, ...resetDefault } = getDefaultBbiProperty?.data?.default_property?.bbi_table?.addition_fields_table_heading || {};
        const { building_fields: defaultFields = [] } =
            isBsi || isBai
                ? getDefaultBsiProperty?.data?.default_property?.bbi_table?.bbi_table_column_configuration?.fields || {}
                : getDefaultBbiProperty?.data?.default_property?.bbi_table?.bbi_table_column_configuration?.fields || {};

        const normalize = name => name?.toLowerCase();

        const defaultTopLevelMap = new Map(defaultFields.map(f => [normalize(f.field_name), f]));
        const defaultNestedFieldsMap = new Map();

        defaultFields.forEach(field => {
            if (field.field_type === "dynamic" && field.selected_fields) {
                Object.values(field.selected_fields).forEach(nestedField => {
                    defaultNestedFieldsMap.set(normalize(nestedField.field_name), {
                        ...nestedField,
                        parentBand: field.field_name
                    });
                });
            }
        });

        const allUserFieldNames = new Set();
        const mergedFields = [];

        (bbiTableFields || []).forEach(field => {
            const normFieldName = normalize(field.field_name);
            allUserFieldNames.add(normFieldName);

            if (field.field_type === "dynamic" && field.selected_fields) {
                // Add nested field names
                Object.values(field.selected_fields).forEach(nested => {
                    allUserFieldNames.add(normalize(nested.field_name));
                });

                const defaultBand = defaultFields.find(d => normalize(d.field_name) === normFieldName);

                const mergedBand = { ...field };
                mergedBand.selected_fields = { ...(field.selected_fields || {}) };

                if (defaultBand?.selected_fields) {
                    Object.entries(defaultBand.selected_fields).forEach(([key, nestedDefault]) => {
                        const normNestedName = normalize(nestedDefault.field_name);
                        const isInBand = Object.values(mergedBand.selected_fields).some(f => normalize(f.field_name) === normNestedName);

                        if (!isInBand && !allUserFieldNames.has(normNestedName)) {
                            mergedBand.selected_fields[key] = {
                                ...nestedDefault,
                                is_active: false
                            };
                        }
                    });
                }

                mergedFields.push(mergedBand);
            } else {
                mergedFields.push(field);
            }
        });

        defaultFields.forEach(defaultField => {
            const normFieldName = normalize(defaultField.field_name);
            if (defaultField.field_type === "dynamic" && !mergedFields.some(f => normalize(f.field_name) === normFieldName)) {
                const bandToAdd = { config: { table_heading: { ...resetDefault, name: normFieldName } || {} }, ...defaultField };
                bandToAdd.selected_fields = {};

                Object.entries(defaultField.selected_fields || {}).forEach(([key, nestedDefault]) => {
                    const normNestedName = normalize(nestedDefault.field_name);
                    if (!allUserFieldNames.has(normNestedName)) {
                        bandToAdd.selected_fields[key] = {
                            ...nestedDefault,
                            is_active: false
                        };
                    }
                });

                if (Object.keys(bandToAdd.selected_fields).length > 0) {
                    mergedFields.push(bandToAdd);
                }
            }
        });

        const nestedFieldsInBands = new Set();
        mergedFields.forEach(f => {
            if (f.field_type === "dynamic" && f.selected_fields) {
                Object.values(f.selected_fields).forEach(nested => {
                    nestedFieldsInBands.add(normalize(nested.field_name));
                });
            }
        });

        defaultFields.forEach(defaultField => {
            if (defaultField.field_type !== "dynamic") {
                const normFieldName = normalize(defaultField.field_name);
                const alreadyIncluded = mergedFields.some(f => normalize(f.field_name) === normFieldName);
                const nestedConflict = nestedFieldsInBands.has(normFieldName);
                if (!alreadyIncluded && !nestedConflict) {
                    if (defaultField?.field_type === "additions") {
                        mergedFields.unshift({ ...defaultField });
                    } else {
                        mergedFields.push({ ...defaultField });
                    }
                }
            }
        });
        return (
            <Portal
                body={
                    <BbiTableConfig
                        isView={isView || viewOnly}
                        isSkeletonView={isSkeletonView}
                        onSave={configFields => {
                            toggleTableConfig();
                            setBbiFields(configFields);
                        }}
                        fieldsConfig={mergedFields}
                        onCancel={() => toggleTableConfig()}
                        isInitialclick={bbiTableFields?.length === 0}
                        isBsi={isBsi}
                        isBai={isBai}
                    />
                }
                onCancel={() => toggleTableConfig()}
            />
        );
    };

    const renderExecutiveSummaryTableModal = () => {
        if (!showExecutiveExportTable) return null;
        return (
            <Portal
                body={
                    <ExecutiveSummaryTable
                        onCancel={() => setShowExecutiveExportTable(false)}
                        onSave={handleExecutiveExportTableSave}
                        viewOnly={viewOnly || isSkeletonView}
                        exportTradeRows={exportTradeRows}
                        isBsi={isBsi}
                        isBai={isBai}
                    />
                }
                onCancel={() => setShowExecutiveExportTable(false)}
            />
        );
    };

    return (
        <>
            <div
                className={`modal modal-region smart-chart-popup bbi-popup-mod ${
                    configData?.chartKey === "sorted_recom" ? "sm-sorted-recom" : ""
                } smartchart-config-popup`}
                id="modalId"
                tabindex="-1"
                style={{ display: "block" }}
            >
                <div className="modal-dialog" role="document">
                    <OuterDraggable handle=".draggable" cancel=".not-draggable" onDrag={handleDrag}>
                        <div className="modal-content outerModal_draggable" style={transform}>
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <div className="txt-hed d-flex align-items-center">{modalheading} Configure</div>
                                    <div className="sys-wrap">
                                        <div className="config-top-rgt-cont">
                                            <div className="check-box-area">
                                                <label
                                                    className={`container-check ${viewOnly || isSkeletonView ? "cursor-diabled" : ""} green-check`}
                                                >
                                                    Select All
                                                    <input
                                                        type="checkbox"
                                                        name="is_bold"
                                                        checked={chartConfigData?.length === 3}
                                                        onClick={e =>
                                                            !viewOnly &&
                                                            !isSkeletonView &&
                                                            handleChartConfigData("allSelect", "", { is_remove: !e.target.checked })
                                                        }
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </h5>
                                <button type="button" className="close" onClick={() => onCancel()}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr">
                                <div className="upload-area not-draggable">
                                    <div className="upload-sec cursor-hand" role="button" tabindex="0">
                                        <input type="file" multiple="" autocomplete="off" tabindex="-1" style={{ display: "none" }} />
                                    </div>
                                </div>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <div className="col-md-12 sm-chart-views pl-1 not-draggable">
                                        <div className="left-box-sm">
                                            {Array(Math.round(defChartView.length / 2))
                                                .fill()
                                                .map((dropRow, rowIndex) => (
                                                    <Droppable
                                                        droppableId={`CHART-VIEW-${rowIndex}`}
                                                        direction="vertical"
                                                        isDropDisabled={isSkeletonView}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <div className="dragble-area" ref={provided.innerRef} {...provided.droppableProps}>
                                                                {defChartView.slice(rowIndex * 2, (rowIndex + 1) * 2).map((view, index) => (
                                                                    <Draggable
                                                                        key={`draggable-chart-view-${rowIndex}${index}`}
                                                                        draggableId={`draggable-chart-view-${rowIndex}${index}`}
                                                                        index={rowIndex * 2 + index}
                                                                        isDragDisabled={isSkeletonView}
                                                                    >
                                                                        {provided => (
                                                                            <div
                                                                                className="box-drg-outr"
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                key={`draggable-${index}`}
                                                                            >
                                                                                <div
                                                                                    className={`drag-item height-item ${
                                                                                        selectedTile === view?.key ? "current-active" : ""
                                                                                    }`}
                                                                                    onClick={() => {
                                                                                        setSelectedTile(view?.key);
                                                                                    }}
                                                                                >
                                                                                    <div className="top-sec sq-ic-out">
                                                                                        <div className="icon">
                                                                                            <img src="/img/icon-squre.svg" alt="icon" />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="cont-sec">
                                                                                        <div className="icons-sec">
                                                                                            <img
                                                                                                src={`/img/${getIconsForView(view?.key)}`}
                                                                                                alt="icon"
                                                                                            />
                                                                                        </div>
                                                                                        <h3>{view?.title}</h3>
                                                                                    </div>
                                                                                    <div className="top-sec">
                                                                                        <div className="icon-pop-flex">
                                                                                            <div className="checkbox">
                                                                                                <label
                                                                                                    className={`container-check ${
                                                                                                        viewOnly || isSkeletonView || isExcelExport
                                                                                                            ? "cursor-diabled"
                                                                                                            : ""
                                                                                                    } green-check`}
                                                                                                >
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        name="is_bold"
                                                                                                        checked={chartConfigData?.includes(view?.key)}
                                                                                                        onClick={e =>
                                                                                                            !viewOnly &&
                                                                                                            !isSkeletonView &&
                                                                                                            handleChartConfigData("view", view?.key, {
                                                                                                                is_remove: !e.target.checked
                                                                                                            })
                                                                                                        }
                                                                                                        disabled={
                                                                                                            viewOnly ||
                                                                                                            isSkeletonView ||
                                                                                                            isExcelExport
                                                                                                        }
                                                                                                    />
                                                                                                    <span className="checkmark"></span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {provided.placeholder}
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                ))}
                                        </div>
                                        <div className="fot-sec top-border types-otr-chart-sec overflw-scrl">
                                            <div className="header-top-txt mb-2">
                                                <img src={viewIcon} alt="icon" />
                                                <h4>{defChartView?.find(chart => chart?.key === selectedTile)?.title} Settings</h4>
                                            </div>
                                            <div className="card p-0 mb-2 mt-0" key={selectedTile}>
                                                <div className="card-header" id={`headingAccordion-${selectedTile}`}>
                                                    <div
                                                        className="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                        type="button"
                                                        data-toggle="collapse"
                                                        data-target={`#collapseAccordion-${selectedTile}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapseAccordion-${selectedTile}`}
                                                    >
                                                        <span className="btn heading-btn-accordion pl-0">Section Heading</span>
                                                    </div>
                                                </div>

                                                <div
                                                    id={`collapseAccordion-${selectedTile}`}
                                                    className="collapse"
                                                    aria-labelledby={`headingAccordion-${selectedTile}`}
                                                >
                                                    <div className="card-body p-0 pt-2">
                                                        <div className="fot-select">
                                                            <label>
                                                                {(isBbi || isBuildingBbi || isBsi || isSiteBsi || isBai) &&
                                                                selectedTile === `table_view`
                                                                    ? "Section Heading"
                                                                    : "Heading"}
                                                            </label>
                                                            <div className="check-box-area">
                                                                <label
                                                                    className={`container-check ${
                                                                        viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                    } green-check`}
                                                                >
                                                                    Yes
                                                                    <input
                                                                        type="checkbox"
                                                                        name="is_bold"
                                                                        checked={heading?.[selectedTile]}
                                                                        onClick={() => {
                                                                            setHeading({ ...heading, [selectedTile]: true });
                                                                        }}
                                                                        disabled={isSkeletonView || viewOnly}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div className="check-box-area">
                                                                <label
                                                                    className={`container-check ${
                                                                        viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                    } green-check`}
                                                                >
                                                                    No
                                                                    <input
                                                                        type="checkbox"
                                                                        name="is_bold"
                                                                        checked={!heading?.[selectedTile]}
                                                                        onClick={() => {
                                                                            setHeading({ ...heading, [selectedTile]: false });
                                                                        }}
                                                                        disabled={isSkeletonView || viewOnly}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {heading?.[selectedTile] && (
                                                            <>
                                                                <div className="fot-select">
                                                                    <label>Heading type</label>
                                                                    <div className="check-box-area">
                                                                        <label
                                                                            className={`container-check ${
                                                                                viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                            } green-check`}
                                                                        >
                                                                            Custom Heading
                                                                            <input
                                                                                type="checkbox"
                                                                                name="is_bold"
                                                                                checked={isCustomTypeHeading?.[selectedTile]}
                                                                                onClick={() => {
                                                                                    setIsCustomTypeHeading({
                                                                                        ...isCustomTypeHeading,
                                                                                        [selectedTile]: true
                                                                                    });
                                                                                }}
                                                                                disabled={isSkeletonView || viewOnly}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="check-box-area">
                                                                        <label
                                                                            className={`container-check ${
                                                                                viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                            } green-check`}
                                                                        >
                                                                            Predefined Heading
                                                                            <input
                                                                                type="checkbox"
                                                                                name="is_bold"
                                                                                checked={!isCustomTypeHeading?.[selectedTile]}
                                                                                onClick={() => {
                                                                                    setIsCustomTypeHeading({
                                                                                        ...isCustomTypeHeading,
                                                                                        [selectedTile]: false
                                                                                    });
                                                                                }}
                                                                                disabled={isSkeletonView || viewOnly}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="card p-0 inner-accordion">
                                                                    <div class="card-header" id="headingOne">
                                                                        <div
                                                                            class="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                                            data-toggle="collapse"
                                                                            data-target="#collapseOne"
                                                                            aria-expanded="true"
                                                                            aria-controls="collapseOne"
                                                                        >
                                                                            <button
                                                                                className="btn heading-btn-accordion"
                                                                                data-toggle="collapse"
                                                                                data-target="#collapseOne"
                                                                                aria-expanded="true"
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                Heading Styles
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    <div id="collapseOne" className="collapse show " aria-labelledby="headingOne">
                                                                        <div class="card-body p-0 pt-2">
                                                                            <TileCustomHeading
                                                                                setHeadingStyleData={setHeadingStyleData}
                                                                                chartView={selectedTile}
                                                                                headingStyleData={headingStyleData}
                                                                                isCustomTypeHeading={isCustomTypeHeading}
                                                                                error={error}
                                                                                viewOnly={viewOnly}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {(isBbi || isBuildingBbi || isBsi || isSiteBsi || isBai) && selectedTile === `table_view` && (
                                                <div className="card p-0 mb-2">
                                                    <div className="card-header" id="headingAccordion2">
                                                        <div
                                                            className="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                            data-toggle="collapse"
                                                            data-target="#collapseAccordion2"
                                                            aria-expanded="false"
                                                            aria-controls="collapseAccordion2"
                                                        >
                                                            <button
                                                                className="btn heading-btn-accordion"
                                                                data-toggle="collapse"
                                                                data-target="#collapseAccordion2"
                                                                aria-expanded="false"
                                                                aria-controls="collapseAccordion2"
                                                            >
                                                                {isBsi ? "BSI" : isBai ? "BAI" : "BBI"} Table Heading
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div id="collapseAccordion2" className="collapse" aria-labelledby="headingAccordion2">
                                                        <div className="card-body p-0 pt-2">
                                                            <div className="fot-select">
                                                                <label>{`${isBsi ? "BSI" : isBai ? "BAI" : "BBI"} Table Heading`}</label>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Yes
                                                                        <input
                                                                            type="checkbox"
                                                                            name="is_bold"
                                                                            checked={heading?.table_main}
                                                                            onClick={() => {
                                                                                setHeading({ ...heading, table_main: true });
                                                                            }}
                                                                            disabled={isSkeletonView || viewOnly}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        No
                                                                        <input
                                                                            type="checkbox"
                                                                            name="is_bold"
                                                                            checked={!heading?.table_main}
                                                                            onClick={() => {
                                                                                setHeading({ ...heading, table_main: false });
                                                                            }}
                                                                            disabled={isSkeletonView || viewOnly}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {(isBbi || isBuildingBbi || isBsi || isSiteBsi || isBai) &&
                                                                selectedTile === `table_view` &&
                                                                heading?.table_main && (
                                                                    <>
                                                                        <div className="fot-select">
                                                                            <label>Heading type</label>
                                                                            <div className="check-box-area">
                                                                                <label
                                                                                    className={`container-check ${
                                                                                        viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                    } green-check`}
                                                                                >
                                                                                    Custom Heading
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name="is_bold"
                                                                                        checked={isCustomTypeHeading?.table_main}
                                                                                        onClick={() => {
                                                                                            setIsCustomTypeHeading({
                                                                                                ...isCustomTypeHeading,
                                                                                                table_main: true
                                                                                            });
                                                                                        }}
                                                                                        disabled={isSkeletonView || viewOnly}
                                                                                    />
                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                            <div className="check-box-area">
                                                                                <label
                                                                                    className={`container-check ${
                                                                                        viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                    } green-check`}
                                                                                >
                                                                                    Predefined Heading
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name="is_bold"
                                                                                        checked={!isCustomTypeHeading?.table_main}
                                                                                        onClick={() => {
                                                                                            setIsCustomTypeHeading({
                                                                                                ...isCustomTypeHeading,
                                                                                                table_main: false
                                                                                            });
                                                                                        }}
                                                                                        disabled={isSkeletonView || viewOnly}
                                                                                    />
                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="card p-0 mb-2 inner-accordion">
                                                                            <div class="card-header" id="headingXyz">
                                                                                <div
                                                                                    class="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                                                    data-toggle="collapse"
                                                                                    data-target="#collapseXyz"
                                                                                    aria-expanded="true"
                                                                                    aria-controls="collapseXyz"
                                                                                >
                                                                                    <button
                                                                                        className="btn heading-btn-accordion"
                                                                                        data-toggle="collapse"
                                                                                        data-target="#collapseXyz"
                                                                                        aria-expanded="true"
                                                                                        aria-controls="collapseXyz"
                                                                                    >
                                                                                        Heading Styles
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            <div
                                                                                id="collapseXyz"
                                                                                className="collapse show "
                                                                                aria-labelledby="headingXyz"
                                                                            >
                                                                                <div class="card-body p-0 pt-2">
                                                                                    <TileCustomHeading
                                                                                        setHeadingStyleData={setHeadingStyleData}
                                                                                        chartView={"table_main"}
                                                                                        headingStyleData={headingStyleData}
                                                                                        isCustomTypeHeading={isCustomTypeHeading}
                                                                                        error={error}
                                                                                        viewOnly={viewOnly}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {selectedTile === `table_view` && (
                                                <>
                                                    <div className="card p-0 mb-2 mt-0" key={selectedTile}>
                                                        <div className="card-header" id={`headingAccordion2-${selectedTile}`}>
                                                            <div
                                                                className="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                                type="button"
                                                                data-toggle="collapse"
                                                                data-target={`#collapseAccordion2-${selectedTile}`}
                                                                aria-expanded="false"
                                                                aria-controls={`collapseAccordion2-${selectedTile}`}
                                                            >
                                                                <span className="btn heading-btn-accordion pl-0">{`${
                                                                    isBsi ? "BSI" : isBai ? "BAI" : "BBI"
                                                                } Table Config`}</span>
                                                            </div>
                                                        </div>

                                                        <div
                                                            id={`collapseAccordion2-${selectedTile}`}
                                                            className="collapse"
                                                            aria-labelledby={`headingAccordion2-${selectedTile}`}
                                                        >
                                                            {/* <div className="wrapper-right-wrap p-0">
                                                                <>
                                                                    {tradeAdditionValues?.additions?.length ? (
                                                                        <>
                                                                            <div className="wrapper-bg-bbi p-0">
                                                                                <h4>
                                                                                    Additional Executive Summary Memo Fields(to be displayed above
                                                                                    main table)
                                                                                </h4>
                                                                                <div className="d-flex">
                                                                                    <div className="formInp d-flex flex-wrap col-md-12 p-0">
                                                                                        {tradeAdditionValues?.additions?.map((value, index) => (
                                                                                            <div className="col-md-4 checkbox-cover" key={index}>
                                                                                                <span className="dropdown-item">
                                                                                                    <label className="container-check">
                                                                                                        <EllipsisTooltipText
                                                                                                            text={value?.label}
                                                                                                            className="overflow-txt-bbi"
                                                                                                        />
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={selectedData?.additions?.includes(
                                                                                                                value?.key
                                                                                                            )}
                                                                                                            onClick={() =>
                                                                                                                handleCheckboxClick(
                                                                                                                    "additions",
                                                                                                                    value?.key
                                                                                                                )
                                                                                                            }
                                                                                                            disabled={viewOnly}
                                                                                                        />
                                                                                                        <span
                                                                                                            className={`checkmark ${
                                                                                                                viewOnly ? "cursor-disabled" : ""
                                                                                                            }`}
                                                                                                        ></span>
                                                                                                    </label>
                                                                                                </span>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : null}
                                                                </>
                                                            </div> */}
                                                            <div className="fot-select">
                                                                <label>{`${isBsi ? "BSI" : isBai ? "BAI" : "BBI"} Table Config`}</label>
                                                                <div className="check-box-area">
                                                                    <button className="btn btn-primary" onClick={toggleTableConfig}>
                                                                        Config
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="fot-select">
                                                                <label>{!isBsi && !isBai ? "FCI/EFCI" : "FCI"}</label>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Percentage
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedData?.displayType === "percentage"}
                                                                            onChange={() =>
                                                                                setSelectedData({
                                                                                    ...selectedData,
                                                                                    displayType: "percentage"
                                                                                })
                                                                            }
                                                                            disabled={isSkeletonView || isView || viewOnly}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Decimal
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedData?.displayType === "text"}
                                                                            onChange={() => setSelectedData({ ...selectedData, displayType: "text" })}
                                                                            disabled={isSkeletonView || isView || viewOnly}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {!isBsi && !isBai ? (
                                                                <>
                                                                    <div className="fot-select">
                                                                        <label>Dynamic memo field</label>
                                                                        <div className="check-box-area">
                                                                            <label
                                                                                className={`container-check ${
                                                                                    isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                } green-check`}
                                                                            >
                                                                                Simple Text
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedData?.bbi_table_memo_simple_text}
                                                                                    onChange={e =>
                                                                                        setSelectedData({
                                                                                            ...selectedData,
                                                                                            bbi_table_memo_simple_text: true
                                                                                        })
                                                                                    }
                                                                                    disabled={isView || viewOnly || isSkeletonView}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="check-box-area">
                                                                            <label
                                                                                className={`container-check ${
                                                                                    isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                } green-check`}
                                                                            >
                                                                                Rich Text
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={!selectedData?.bbi_table_memo_simple_text}
                                                                                    onChange={e =>
                                                                                        setSelectedData({
                                                                                            ...selectedData,
                                                                                            bbi_table_memo_simple_text: false
                                                                                        })
                                                                                    }
                                                                                    disabled={isView || viewOnly || isSkeletonView}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="fot-select">
                                                                        <label>Date Format</label>
                                                                        <div className="check-box-area">
                                                                            <label
                                                                                className={`container-check ${
                                                                                    isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                } green-check`}
                                                                            >
                                                                                MM-DD-YYYY
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        selectedData?.bbi_table_date_format === "standard-us-numeric"
                                                                                    }
                                                                                    onChange={() =>
                                                                                        setSelectedData({
                                                                                            ...selectedData,
                                                                                            bbi_table_date_format: "standard-us-numeric"
                                                                                        })
                                                                                    }
                                                                                    disabled={isSkeletonView || isView || viewOnly}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="check-box-area">
                                                                            <label
                                                                                className={`container-check ${
                                                                                    isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                                } green-check`}
                                                                            >
                                                                                MMMM DD, YYYY
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        selectedData?.bbi_table_date_format === "month_name-day-year"
                                                                                    }
                                                                                    onChange={() =>
                                                                                        setSelectedData({
                                                                                            ...selectedData,
                                                                                            bbi_table_date_format: "month_name-day-year"
                                                                                        })
                                                                                    }
                                                                                    disabled={isSkeletonView || isView || viewOnly}
                                                                                />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {selectedTile === `executive_summary_data` && (
                                                <>
                                                    {" "}
                                                    <div className="card p-0 mb-2 mt-0" key={selectedTile}>
                                                        <div className="card-header" id={`headingAccordion3-${selectedTile}`}>
                                                            <div
                                                                className="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                                type="button"
                                                                data-toggle="collapse"
                                                                data-target={`#collapseAccordion3-${selectedTile}`}
                                                                aria-expanded="false"
                                                                aria-controls={`collapseAccordion3-${selectedTile}`}
                                                            >
                                                                <span className="btn heading-btn-accordion pl-0">
                                                                    {" "}
                                                                    Executive Summary Bands to Export
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div
                                                            id={`collapseAccordion3-${selectedTile}`}
                                                            className="collapse pr-1"
                                                            aria-labelledby={`headingAccordion3-${selectedTile}`}
                                                        >
                                                            {/* <div className="wrapper-right-wrap p-0">
                                                                <>
                                                                    {tradeAdditionValues?.additions?.length ? (
                                                                        <>
                                                                            <div className="wrapper-bg-bbi p-0">
                                                                                <h4>
                                                                                    Additional Executive Summary Memo Fields(to be displayed above
                                                                                    main table)
                                                                                </h4>
                                                                                <div className="d-flex">
                                                                                    <div className="formInp d-flex flex-wrap col-md-12 p-0">
                                                                                        {tradeAdditionValues?.additions?.map((value, index) => (
                                                                                            <div className="col-md-4 checkbox-cover" key={index}>
                                                                                                <span className="dropdown-item">
                                                                                                    <label className="container-check">
                                                                                                        <EllipsisTooltipText
                                                                                                            text={value?.label}
                                                                                                            className="overflow-txt-bbi"
                                                                                                        />
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={selectedData?.additions?.includes(
                                                                                                                value?.key
                                                                                                            )}
                                                                                                            onClick={() =>
                                                                                                                handleCheckboxClick(
                                                                                                                    "additions",
                                                                                                                    value?.key
                                                                                                                )
                                                                                                            }
                                                                                                            disabled={viewOnly}
                                                                                                        />
                                                                                                        <span
                                                                                                            className={`checkmark ${
                                                                                                                viewOnly ? "cursor-disabled" : ""
                                                                                                            }`}
                                                                                                        ></span>
                                                                                                    </label>
                                                                                                </span>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : null}
                                                                </>
                                                            </div> */}
                                                            {exportTradeRows?.length > 0 ? (
                                                                <>
                                                                    <div className="wrapper-bg-bbi p-0 m-0 mb-1">
                                                                        <ReactTooltip
                                                                            id="config-tooltip"
                                                                            place="top"
                                                                            effect="solid"
                                                                            className="rc-tooltip-custom-class"
                                                                            backgroundColor="#007bff"
                                                                            multiline={true}
                                                                        />
                                                                        <h4 className="trade-label-nme p-0 mt-0">
                                                                            Executive Summary{" "}
                                                                            <label className="trade-sub-txt">
                                                                                <div class="container-check mb-0 pl-4">
                                                                                    <span class="pl-1" data-for="arch">
                                                                                        Export Trade Summary even if No Recommendations
                                                                                    </span>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={
                                                                                            projectTradeData?.length > 0 &&
                                                                                            projectTradeData?.every(projectTrade =>
                                                                                                exportTradeRows?.some(
                                                                                                    row =>
                                                                                                        row?.id === projectTrade?.id &&
                                                                                                        row?.export === "yes"
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        onClick={e => handleExportTradeSummaryCheckboxClick(e)}
                                                                                        disabled={viewOnly || projectTradeData?.length === 0}
                                                                                    />
                                                                                    <span
                                                                                        class={`checkmark ${viewOnly || projectTradeData?.length === 0 ? "cursor-disabled" : ""}`}
                                                                                        data-for="config-tooltip"
                                                                                        data-tip={
                                                                                            projectTradeData?.length === 0
                                                                                                ? "This option can’t be selected, as all trades are included in the recommendations"
                                                                                                : ""
                                                                                        }
                                                                                    ></span>
                                                                                </div>
                                                                            </label>
                                                                        </h4>
                                                                        <div className="d-flex flex-wrap align-items-center mb-2 mt-1">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary not-draggable mr-2 mb-3 mt-3 ml-1 p-2 btn-executive-export"
                                                                                onClick={() => setShowExecutiveExportTable(true)}
                                                                            >
                                                                                Executive Summary Bands Config (Export Y/N and Location)
                                                                            </button>
                                                                        </div>
                                                                        {/* <div className="d-flex">
                                                                            <div className="formInp d-flex flex-wrap col-md-12 p-0">
                                                                                {tradeAdditionValues?.trades?.map((value, index) => (
                                                                                    <div className="col-md-4 checkbox-cover" key={index}>
                                                                                        <span className="dropdown-item">
                                                                                            <label className="container-check">
                                                                                                <EllipsisTooltipText
                                                                                                    text={value?.name}
                                                                                                    className="overflow-txt-bbi"
                                                                                                />
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={selectedData?.trades?.includes(
                                                                                                        value?.id
                                                                                                    )}
                                                                                                    onClick={() =>
                                                                                                        handleCheckboxClick("trades", value?.id)
                                                                                                    }
                                                                                                    disabled={viewOnly}
                                                                                                />
                                                                                                <span
                                                                                                    className={`checkmark ${
                                                                                                        viewOnly ? "cursor-disabled" : ""
                                                                                                    }`}
                                                                                                ></span>
                                                                                            </label>
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div> */}
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                            <div className="fot-select">
                                                                <label>Executive Summary Text Properties</label>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Simple Text
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedData?.simpleText}
                                                                            onChange={e => setSelectedData({ ...selectedData, simpleText: true })}
                                                                            disabled={isView || viewOnly || isSkeletonView}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Rich Text
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!selectedData?.simpleText}
                                                                            onChange={e => setSelectedData({ ...selectedData, simpleText: false })}
                                                                            disabled={isView || viewOnly || isSkeletonView}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="fot-select">
                                                                <label>
                                                                    {isBsi
                                                                        ? "Show BSI XSUM Recommendations"
                                                                        : isBai
                                                                          ? "Show BAI XSUM Recommendations"
                                                                          : "Show BBI XSUM Recommendations"}
                                                                </label>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        Yes
                                                                        <input
                                                                            type="checkbox"
                                                                            name="is_bold"
                                                                            checked={showBbiXsum}
                                                                            onChange={e => setBbiXsum(true)}
                                                                            disabled={isSkeletonView || isView}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="check-box-area">
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || isSkeletonView ? "cursor-diabled" : ""
                                                                        } green-check`}
                                                                    >
                                                                        No
                                                                        <input
                                                                            type="checkbox"
                                                                            name="is_bold"
                                                                            checked={!showBbiXsum}
                                                                            onChange={e => setBbiXsum(false)}
                                                                            disabled={isSkeletonView || isView}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <div className="fot-select">
                                                <label>Page Break</label>
                                                <div className="check-box-area">
                                                    <label
                                                        className={`container-check ${
                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                        } green-check`}
                                                    >
                                                        Yes
                                                        <input
                                                            type="checkbox"
                                                            name="is_bold"
                                                            checked={pageBreak[selectedTile]}
                                                            onClick={e => setPageBreak({ ...pageBreak, [selectedTile]: true })}
                                                            disabled={isSkeletonView || isView || viewOnly}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="check-box-area">
                                                    <label
                                                        className={`container-check ${
                                                            isView || viewOnly || isSkeletonView ? "cursor-diabled" : ""
                                                        } green-check`}
                                                    >
                                                        No
                                                        <input
                                                            type="checkbox"
                                                            name="is_bold"
                                                            checked={!pageBreak[selectedTile]}
                                                            onClick={e => setPageBreak({ ...pageBreak, [selectedTile]: false })}
                                                            disabled={isSkeletonView || isView || viewOnly}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </DragDropContext>
                                <div className="btn-sec not-draggable">
                                    <div className="text-right btnOtr edit-cmn-btn mt-4">
                                        {Object.values(error)?.some(value => value === true) && (
                                            <span className="errorMessage">
                                                {`* Required field${
                                                    Object.values(error).filter(value => value === true).length > 1 ? "s are" : " is"
                                                } missing`}
                                            </span>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-secondary btnClr col-md-2 mr-3"
                                            data-dismiss="modal"
                                            onClick={() => handleClickCancel()}
                                        >
                                            Cancel
                                        </button>
                                        {!viewOnly && !isSkeletonView ? (
                                            <button
                                                type="button"
                                                className={`btn btn-primary btnRgion col-md-2 ${
                                                    !chartConfigData?.length || isLoading ? "cursor-disabled" : ""
                                                }`}
                                                onClick={() => handleClickSave()}
                                                disabled={!chartConfigData?.length || isLoading}
                                            >
                                                {btnName}
                                                {isLoading && (
                                                    <span className="edit-icn-bx icon-btn-sec cursor-disabled ml-2">
                                                        <div className="spinner-border text-white" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </span>
                                                )}
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OuterDraggable>
                </div>
                {renderTableConfig()}
                {renderExecutiveSummaryTableModal()}
            </div>
        </>
    );
};

export default ConfigModal;
